const colors = {
    cyan: '#2CC2D3',
    darkCyan: '#21929E',
    lightCyan:'#EAF9FB',
    brownRed:'#B43236'
  };
  
  export default colors;
  